import { ClauseResponse } from './model';

export const enum DetailsPolicyActionTypes {
  FETCH_POLICY_VIEW_MODEL = '@@detailsPolicy/FETCH_POLICY_VIEW_MODEL',
  FETCH_POLICY_VIEW_MODEL_SUCCESS = '@@detailsPolicy/FETCH_POLICY_VIEW_MODEL_SUCCESS',
  FETCH_POLICY_VIEW_MODEL_FAIL = '@@detailsPolicy/FETCH_POLICY_VIEW_MODEL_FAIL',
  RESET_STATE = '@@detailsPolicy/RESET_STATE'
}

export const enum PolicySubTypeTCEnum {
  BELFIUS_HOME = 'BELFIUS HOME',
  DVV_BRAND = 'DVV BRAND'
}

export interface Policy {
  readonly insurerPartyName: string;
  readonly contractNumber: number;
  readonly policySubTypeTC: string;
  readonly contractClassification: string;
  readonly policyTypeTC: string;
  readonly contractName: string;
  readonly policyCode: string;
  readonly inspectorName: string;
  readonly conditions: string;
  readonly dateOfCommencement: Date | string;
  readonly dateOfExpiration: Date | string;
  readonly indirectLossesPercentage: number;
  readonly buildingIndexSubscription: number;
  readonly buildingIndexClaim: number;
  readonly consumptionIndexSubscription: number;
  readonly consumptionIndexClaim: number;
  readonly legalExcessAmount: number;
  readonly loweredExcessAmountThreshold: number;
  readonly damageCaseCode: string;
  readonly docNotificationDamageLossDate: Date | '';
  readonly insuredAmountBuilding: number;
  readonly excessAmountBuilding: number;
  readonly raisedExcessAmountBuilding: number;
  readonly indirectLossesBuilding: boolean;
  readonly guaranteeTCBuilding: string;
  readonly insuredAmountContent: number;
  readonly excessAmountContent: number;
  readonly raisedExcessAmountContent: number;
  readonly indirectLossesContent: boolean;
  readonly guaranteeTCContent: string;
  readonly policyHolderLanguageTC: string;
  readonly DVVStarsUsed: boolean;
  readonly EnglishFranchise: boolean;
}

export interface InsuredRisk {
  readonly street: string;
  readonly buildingNumber: number;
  readonly boxNumber: number;
  readonly zipCode: number;
  readonly city: string;
  readonly country: string;
  readonly locationDescription: string;
  readonly constructionYear: number;
  readonly typeOfProperty: string;
  readonly typeOfConstruction: string;
  readonly hasElevator: boolean;
  readonly isListed: boolean;
  readonly hasRoomsWithCeilingHigherThan4m: boolean;
  readonly hasInstalledKitchen: boolean;
  readonly hasCentralHeating: boolean;
  readonly hasRoofingFromCaneOrStraw: boolean;
  readonly hasMoreThanOneSideInNaturalStone: boolean;
  readonly hasHeatedSwimmingPool: boolean;
  readonly hasASideOfBuildingBiggerThan40SquareMeters: boolean;
  readonly hasMoreThan5Floors: boolean;
  readonly hasFloorInNaturalStoneOrSolidParquet: boolean;
  readonly numberOfInsuredSurfaces: number;
  readonly numberOfRooms: number;
  readonly numberOfLivingRooms: number;
  readonly numberOfBathrooms: number;
  readonly numberOfGarages: number;
  readonly numberOfOffices: number;
  readonly numberOfBedrooms: number;
  readonly numberOfKitchens: number;
  readonly numberOfOtherPlaces: number;
  readonly numberOfConservatories: number;
}

export interface Clause {
  readonly code: string;
  readonly name: string;
  readonly description: string[];
}

export interface Guarantee {
  readonly object: string;
  readonly objectSequence: number;
  readonly guarantee: string;
  readonly guaranteeSequence: number;
  readonly startDate: Date;
  readonly endDate: Date;
  readonly excessAmount: number;
  readonly insuredAmount: number;
  readonly indirectLosses: boolean;
}

export interface DetailsPolicyState {
  readonly policy: Policy;
  readonly insuredRisk: InsuredRisk;
  readonly clauses: ClauseResponse[];
  readonly guarantees: Guarantee[];
}
